import Inline from "./Inline";

export default Inline;



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepSimulation/surveyStep/SimulatedSurvey/Content/Inline/index.js